<a360-icon
  icon="cross"
  [color]="colorClassName"
  [hoverColor]="changeOnHover ? iconColors.RED : colorClassName"
  [width]="crossSize"
  [height]="crossSize"
  [autId]="'cross-icon'"
  [isButton]="true"
  [iconTitle]="iconTitle"
></a360-icon>
